import { useTranslation } from "react-i18next";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";

import CloseIcon from "assets/icons/close.svg?react";
import { useNavigate } from "react-router-dom";
import casesService from "api/casesService";
import CaseIcon from "assets/icons/case.svg?react";

const CaseRelationsModal: FC<Props> = ({ toggle, CaseId }) => {
  const { t } = useTranslation();
  const { data: CaseData } = casesService.useGetCase(CaseId ?? "");


  const openCase = (id: string) => {
    navigate(`/cases/${id}/chat`);
  };

  const navigate = useNavigate();
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.title}>
          {t("modals.relations")}
          <CloseIcon
            className={styles.closeIcon}
            onClick={() => toggle(false)}
          />
        </div>
        <div className={styles.list}>
          {CaseData?.Relations.map((r) => (
            <div key={r.Id} className={styles.case}>
              <div className={styles.metaData}>
                <div className={styles.signature}>{r.Signature}</div>
                <div className={styles.client}>{r.Principal}</div>
              </div>

              <div className={styles.menu}>
                <CaseIcon onClick={() => openCase(r.CaseId)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseRelationsModal;
